/**
 * @description 发行详情-发售详情卡片
*/

import React, { useState, useEffect, useRef } from "react";
import { round } from "@/utils/publicFun"
import "./index.scss";

const DetailCard = (props) => {

	const {dataSouce={}, config={}} = props
	const issuerLogo = config?.issuerLogo || dataSouce?.issuerLogo;

	return (
		<div className="detailCard">
			<div className="content_title">发售详情</div>
			<div className="content_spacebt">
				<span>发行价格</span>
				<span>¥{round(dataSouce.price, 2)}</span>
			</div>
			<p className="content_radio">{config?.couponPoint == 1 ? '可使用专属优惠券，不可使用积分抵扣' : '不可使用积分抵扣'}</p>
			<div className="content_spacebt">
				<span>发行时间</span>
				<span>{dataSouce.subtitle || ''}</span>
			</div>
			<div className="content_spacebt">
				<span>发行数量</span>
				<span>{dataSouce.supply || 0}份</span>
			</div>
			{
				dataSouce.rarity &&
				<div className="content_spacebt">
					<span>稀有度</span>
					<span style={{color: '#CEBF7E'}}>{dataSouce.rarity}</span>
				</div>
			}
			<div className="content_spacebt">
				<span>发行方</span>
				<div className="content_home">
					{issuerLogo ? (
						<img className="issuer_logo" src={issuerLogo} alt="" />
					) : dataSouce.collectionType === 312 || dataSouce.collectionType === 313 ? (
						<div className="div2"></div>
					) : (
						<div className="div1"></div>
					)}
					{dataSouce.owner || '绿地集团'}
				</div>
			</div>
		</div>
	)
}

export default DetailCard;